/**
 * key 和 value 里面的 path 属性保持一致, 都是整体路由
 * value 的一些属性备注
 *     name 标题
 *     layout 示例布局 1: 左右布局 2: 上下布局
 *     exImg 示例图
 *     intro 功能介绍文字数组, 每项占一行
 *     used 使用场景文字数组, 每项占一行
 *     notice 注意文字数组, 每项占一行, 最后一行加微信不在此内, 那个要在渲染时手动加上去
 */
const introData = {
    '/head_screen/recommend': {
        name: '手淘推荐',
        path: '/head_sscreen/recommend',
        layout: 1,
        exImg: require("@/index/assets/exImg/手淘推荐示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、增加新品成交的路径，提升商品出资按在首页概率，可通过使用此功能提升新品排名。",
            "2、通过这个路径搜索下单提升的权重比常’的卡首屏提升高很多。",
            "3、配合主持下单、旺旺强行达标下单能实现较小的成本以提升成交后的权重。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/nicegoods': {
        name: '有好货入口',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/guess': {
        name: '猜你喜欢',
        path: '/tbmobile/guess',
        layout: 2,
        exImg: require("@/index/assets/exImg/手淘推荐-其它猜你喜欢示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在下。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/hbooth': {
        name: '智钻',
        path: '/tbmobile/hbooth',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/globalshop': {
        name: '全球购入口',
        path: '/tbmobile/globalshop',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/dayshops': {
        name: '每日好店入口',
        path: '/tbmobile/dayshops',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/robshop': {
        name: '淘抢购入口',
        path: '/tbmobile/robshop',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/coins': {
        name: '淘金币',
        path: '/head_screen/coins',
        layout: 2,
        exImg: require("@/index/assets/exImg/淘金币示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            // 淘金币的使用场景第一个要特殊处理
            "2、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "3、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "4、生成二维码不限时间和次数，效果图在下。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/life': {
        name: '生活研究所',
        path: '/head_screen/life',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/iFashion': {
        name: 'iFashion',
        path: '/tbmobile/iFashion',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/micro-details': { // 微详情要调用不同的接口, 且不同的表单, 注意
        name: '微详情',
        path: '/head_screen/micro-details',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/ask-everyone': {
        name: '问大家',
        path: '/head_screen/ask-everyone',
        layout: 1,
        exImg: require("@/index/assets/exImg/问大家示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/probaby': {
        name: '亲宝贝',
        path: '/tbmobile/probaby',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/buy-ask-everyone': {
        name: '购后猜你喜欢',
        path: '/head_screen/buy-ask-everyone',
        layout: 2,
        exImg: require("@/index/assets/exImg/手淘推荐-其它猜你喜欢示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/first-order-discount': {
        name: '首单优惠',
        path: '/head_screen/first-order-discount',
        layout: 1,
        exImg: require("@/index/assets/exImg/首单优惠示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/farm': {
        name: '芭芭农场',
        path: '/head_screen/farm',
        layout: 1,
        exImg: require("@/index/assets/exImg/芭芭农场示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/wangwang': {
        name: '手淘旺旺',
        path: '/head_screen/wangwang',
        layout: 1,
        exImg: require("@/index/assets/exImg/手淘旺旺示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/other-shop': {
        name: '手淘其它商品详情页',
        path: '/head_screen/other-shop',
        layout: 1,
        exImg: require("@/index/assets/exImg/手淘其它商品详情页-示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，扫码后直接进入到商品介绍页。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID、竞品ID-1、竞品ID-2,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/other-fee': {
        name: '淘内免费其它(通用版)',
        path: '/head_screen/other-fee',
        layout: 1,
        exImg: require("@/index/assets/exImg/淘内免费其它（通用）示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/black-box': {
        name: '小黑盒',
        path: '/head_screen/black-box',
        layout: 1,
        exImg: require("@/index/assets/exImg/小黑盒示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/new-products': {
        name: '新品推荐',
        path: '/head_screen/new-products',
        layout: 1,
        exImg: require("@/index/assets/exImg/新品推荐示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、先浏览其它相似款的宝贝，每个随机浏览1-5分钟，再浏览要成交的商品，浏览时间稍微久点，然后收藏加购付款成交。",
            "3、通过相似款商品后达成的成交，权重比直接浏览成交高，能提高宝贝自然排名搜索。",
            "4、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/checkNum/similarImport': {
        name: '相似宝贝',
        path: '/checkNum/similarImport',
        layout: 1,
        exImg: require("@/index/assets/exImg/相似宝贝示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、先浏览其它相似款的宝贝，每个随机浏览1-5分钟，再浏览要成交的商品，浏览时间稍微久点，然后收藏加购付款成交。",
            "3、通过相似款商品后达成的成交，权重比直接浏览成交高，能提高宝贝自然排名搜索。",
            "4、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/firstPause': { // 单独做一个路又跳转, 没有其他额外的操作
        name: '【高权重】搜索卡首屏',
        path: '/head_screen/firstPause',
        layout: 1,
        exImg: require("@/index/assets/exImg/【高权重】搜索卡首屏新.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID、关键词,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/buyers-show': {
        name: '买家秀',
        path: '/head_screen/buyers-show',
        layout: 1,
        exImg: require("@/index/assets/exImg/买家秀示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品买家秀ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/daily-deals': {
        name: '天天特卖卡首批',
        path: '/head_screen/daily-deals',
        layout: 1,
        exImg: require("@/index/assets/exImg/天天特卖示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/poly-cost-effective': {
        name: '聚划算品牌特卖',
        path: '/head_screen/poly-cost-effective',
        layout: 1,
        exImg: require("@/index/assets/exImg/聚划算品牌特卖示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、商品需要参加聚划算活动",
            "2、输入商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "3、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "4、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/head_screen/buy-page': {
        name: '支付页-猜你喜欢-流量来源手淘推荐',
        path: '/head_screen/buy-page',
        layout: 2,
        exImg: require("@/index/assets/exImg/手淘推荐-其它猜你喜欢示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID、关键词,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/checkNum/firstPause': { // 单独做一个路又跳转, 没有其他额外的操作
        name: '关键词卡首屏',
        path: '/checkNum/firstPause',
        layout: 1,
        exImg: require("@/index/assets/exImg/【高权重】搜索卡首屏新.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID、关键词,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },

    // 20240307
    '/tbmobile/brand-undergarments': {
        name: 'U先试用',
        path: '/tbmobile/brand-undergarments',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tm-live': {
        name: '手淘直播',
        path: '/tbmobile/tm-live',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tnei-discover': {
        name: '淘内待分类-精选发现',
        path: '/tbmobile/tnei-discover',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tnei-recommandations': {
        name: '淘内待分类-为你推荐',
        path: '/tbmobile/tnei-recommandations',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [
            "1、用户扫描二维码后，会在生意参谋中，显示该访客是通过淘内免费来源访问到你的商品的，商品也会在手淘首页商品列表考前的位置。",
            "2、商品需要是违被拉黑的可在手淘推荐中入池的商品，未被收录的商品回头失败率。",
            "3、通过这样卡位的方式将商品卡在手淘首页的商品列表中，提升商品的搜索路径的权重值。",
        ],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码和微信短链接。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tmr-topic-cloud': {
        name: '手淘推荐云主题',
        path: '/tbmobile/tmr-topic-cloud',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tm-must-list': {
        name: '手淘必买清单',
        path: '/tbmobile/tm-must-list',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/details-main-img': {
        name: '详情页头图推荐',
        path: '/tbmobile/details-main-img',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    // '/tbmobile/short-video-fullpage': {
    //     name: '短视频全屏页',
    //     path: '/tbmobile/short-video-fullpage',
    //     layout: 1,
    //     exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
    //     intro: [],
    //     used: [
    //         "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
    //         "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
    //         "3、生成二维码不限时间和次数，效果图在右。"
    //     ],
    //     notice: [
    //         "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
    //         "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
    //         "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
    //     ],
    // },
    '/tbmobile/tm-nice-price': {
        name: '手淘有好价',
        path: '/tbmobile/tm-nice-price',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tm-plt': {
        name: '手淘拍立淘',
        path: '/tbmobile/tm-plt',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tm-nice-goodies': {
        name: '淘宝好货推荐',
        path: '/tbmobile/tm-nice-goodies',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tiny-black-box': {
        name: '小黑盒卡首屏',
        path: '/tbmobile/tiny-black-box',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/guess-your-like-star': {
        name: '猜你喜欢小星星',
        path: '/tbmobile/guess-your-like-star',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/first-order-coupon': {
        name: '首单优惠礼金卡首页',
        path: '/tbmobile/first-order-coupon',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/taobao-foodie': {
        name: '淘宝吃货',
        path: '/tbmobile/taobao-foodie',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/trend-play': {
        name: '潮玩世界',
        path: '/tbmobile/trend-play',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/holiday-guide': {
        name: '节日指南',
        path: '/tbmobile/holiday-guide',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/piece-house': {
        name: '每平每屋',
        path: '/tbmobile/piece-house',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/my-cute-pets': {
        name: '我的萌宠',
        path: '/tbmobile/my-cute-pets',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/cat-fresh-food': {
        name: '喵鲜生',
        path: '/tbmobile/cat-fresh-food',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/trend-woo': {
        name: '潮WOO',
        path: '/tbmobile/trend-woo',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/cool-planet': {
        name: '酷玩星球',
        path: '/tbmobile/cool-planet',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/odp': {
        name: '海外直购',
        path: '/tbmobile/odp',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/global-purchase': {
        name: '全球购',
        path: '/tbmobile/global-purchase',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tm-neighbor-goodies': {
        name: '邻家好货手淘',
        path: '/tbmobile/tm-neighbor-goodies',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tmall-international': {
        name: '天猫国际',
        path: '/tbmobile/tmall-international',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tmall-luxury': {
        name: '天猫奢品',
        path: '/tbmobile/tmall-luxury',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tmall-apple-fans': {
        name: '天猫果粉',
        path: '/tbmobile/tmall-apple-fans',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tmall-list': {
        name: '天猫榜单',
        path: '/tbmobile/tmall-list',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },
    '/tbmobile/tmall-creation': {
        name: '天猫造新',
        path: '/tbmobile/tmall-creation',
        layout: 1,
        exImg: require("@/index/assets/exImg/微详情示例图.jpeg"),
        intro: [],
        used: [
            "1、先输入要商品链接或ID,点开始生成即可生成卡首屏二维码。",
            "2、打开手机淘宝扫二维码或者通过微信短链接跳转方式把宝贝卡在首页。",
            "3、生成二维码不限时间和次数，效果图在右。"
        ],
        notice: [
            "1、商品不能是被电商平台屏蔽拉黑的商品，因为这样的商品很难卡出来，即使卡成功对于提升权重也无效果。",
            "2、新品使用该功能的时候，要确保店铺有一定的权重，零基础的店铺卡到商品较难。",
            "3、商品需要是能入池的商品，就是商品能被手淘首页收录入池。",
        ],
    },

    '/head_screen/everyday-low-price': {
        name: '天天低价',
        path: '/head_screen/everyday-low-price',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/post-purchase-recommandations': {
        name: '购后推荐',
        path: '/head_screen/post-purchase-recommandations',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tb-good-price': {
        name: '淘宝好价',
        path: '/head_screen/tb-good-price',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tnei-unclassified': {
        name: '淘内待分类-通用',
        path: '/head_screen/tnei-unclassified',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tnei-guess-like': {
        name: '淘内待分类-猜你喜欢',
        path: '/head_screen/tnei-guess-like',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/billions-subsidies': {
        name: '百亿补贴',
        path: '/head_screen/billions-subsidies',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/car-life': {
        name: '爱车生活',
        path: '/head_screen/car-life',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/favorable-life': {
        name: '惠生活',
        path: '/head_screen/favorable-life',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/domestic-electric-appliance': {
        name: '生活电器',
        path: '/head_screen/domestic-electric-appliance',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/trend-electric-digital': {
        name: '潮电数码',
        path: '/head_screen/trend-electric-digital',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/deep-in-autumn': {
        name: '踏秋季',
        path: '/head_screen/deep-in-autumn',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tend-fun-festival': {
        name: '潮玩节',
        path: '/head_screen/tend-fun-festival',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/fun-season': {
        name: '趣玩季',
        path: '/head_screen/fun-season',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/dopamine': {
        name: '多巴胺',
        path: '/head_screen/dopamine',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/pet-day': {
        name: '爱宠日',
        path: '/head_screen/pet-day',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/ice-festival': {
        name: '冰雪节',
        path: '/head_screen/ice-festival',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/valentine-day': {
        name: '情人节',
        path: '/head_screen/valentine-day',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/hot-sale-shoes-boots': {
        name: '热卖鞋靴',
        path: '/head_screen/hot-sale-shoes-boots',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/live-dress': {
        name: '服饰直播',
        path: '/head_screen/live-dress',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/spring-new': {
        name: '春季新品',
        path: '/head_screen/spring-new',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/global-trend': {
        name: '全球新趋势',
        path: '/head_screen/global-trend',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/global-discover': {
        name: '全球新发现',
        path: '/head_screen/global-discover',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/international-self-support': {
        name: '国际自营',
        path: '/head_screen/international-self-support',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/home-appliance': {
        name: '家居电器',
        path: '/head_screen/home-appliance',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/home-improvement-goodies': {
        name: '家装好物',
        path: '/head_screen/home-improvement-goodies',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/home-improvement-nice-price': {
        name: '家装好价',
        path: '/head_screen/home-improvement-nice-price',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/home-must-have': {
        name: '宅家必备',
        path: '/head_screen/home-must-have',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/home-enjoy-life': {
        name: '家享生活',
        path: '/head_screen/home-enjoy-life',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/fashion': {
        name: '服饰时尚',
        path: '/head_screen/fashion',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/boutique-furniture': {
        name: '精品家具',
        path: '/head_screen/boutique-furniture',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/quality-applicance': {
        name: '品质家电',
        path: '/head_screen/quality-applicance',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/sport-trend': {
        name: '运动新潮',
        path: '/head_screen/sport-trend',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/sport-goodies': {
        name: '运动好物',
        path: '/head_screen/sport-goodies',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/enjoy-nice-food': {
        name: '美食嗨吃',
        path: '/head_screen/enjoy-nice-food',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/beauty-toiletry': {
        name: '美妆洗护',
        path: '/head_screen/beauty-toiletry',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/mother-baby': {
        name: '母婴亲子',
        path: '/head_screen/mother-baby',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/culture': {
        name: '文教香氛',
        path: '/head_screen/culture',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/corporate-procurement': {
        name: '企业采购',
        path: '/head_screen/corporate-procurement',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/corporate-culture': {
        name: '宠企文教',
        path: '/head_screen/corporate-culture',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/publish-trend': {
        name: '趋势发布',
        path: '/head_screen/publish-trend',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/supper-item': {
        name: '超级单品',
        path: '/head_screen/supper-item',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/jewelry': {
        name: '珠宝饰品',
        path: '/head_screen/jewelry',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-ceremony': {
        name: '品牌盛典',
        path: '/head_screen/brand-ceremony',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/woman-fashion': {
        name: '流行女装',
        path: '/head_screen/woman-fashion',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/subtlety-pet': {
        name: '精致养宠',
        path: '/head_screen/subtlety-pet',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/watch-eyeglasses': {
        name: '手表眼镜',
        path: '/head_screen/watch-eyeglasses',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/health-life': {
        name: '健康生活',
        path: '/head_screen/health-life',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/kitchenette': {
        name: '厨房家居',
        path: '/head_screen/kitchenette',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/pre-enjoy-trend': {
        name: '潮玩早享',
        path: '/head_screen/pre-enjoy-trend',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/bedding-home-decor': {
        name: '床品家饰',
        path: '/head_screen/bedding-home-decor',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/spring-newest': {
        name: '春季上新',
        path: '/head_screen/spring-newest',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tmall-u-first': {
        name: '天猫U先',
        path: '/head_screen/tmall-u-first',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tmall-market': {
        name: '天猫超市',
        path: '/head_screen/tmall-market',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/tmall-medicine': {
        name: '天猫买药',
        path: '/head_screen/tmall-medicine',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-digital': {
        name: '大牌数码',
        path: '/head_screen/brand-digital',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-jewelry': {
        name: '大牌珠宝',
        path: '/head_screen/brand-jewelry',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-mother-baby': {
        name: '大牌母婴',
        path: '/head_screen/brand-mother-baby',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-home-cleaner': {
        name: '大牌家清',
        path: '/head_screen/brand-home-cleaner',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-personal-care': {
        name: '大牌个护',
        path: '/head_screen/brand-personal-care',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-beauty': {
        name: '大牌美妆',
        path: '/head_screen/brand-beauty',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-man-clothes': {
        name: '大牌男装',
        path: '/head_screen/brand-man-clothes',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '/head_screen/brand-undergarments': {
        name: '大牌内衣',
        path: '/head_screen/brand-undergarments',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
    '': {
        name: '',
        path: '',
        layout: 1,
        exImg: '',
        intro: [],
        used: [],
        notice: [],
    },
}

export {
    introData,
}
